import FormDialog from '@/components/ui/form-dialog';
import { FunctionComponent, ReactElement } from 'react';
import { SingleSite } from '@/core/entities';
import { useMutation } from '@tanstack/react-query';
import { deleteSite } from '@/api/sites';
import useToastMessage from '@/shared/context/toast-message-context';
import { pushToDataLayer, ContentGroup } from '@/shared/utils/analytics';

interface DeleteSiteFormProps {
	open: boolean;
	onClose: () => void;
	site?: SingleSite;
	onSubmitted?: () => void;
	customerName: string;
}

const DeleteSiteForm: FunctionComponent<DeleteSiteFormProps> = ({
	open,
	onClose,
	site,
	onSubmitted,
	customerName,
}): ReactElement => {
	const { dispatch } = useToastMessage();

	const trackRemoveSite = () => {
		pushToDataLayer({
			event: 'site_removed',
			content_group: ContentGroup.Customers,
			customer_name: customerName,
		});
	};

	const { mutate } = useMutation({
		mutationFn: (id: string) => deleteSite(id),
		onSuccess: () => {
			dispatch({
				type: 'success',
				content: 'Site successfully deleted',
			});
			onClose();
			onSubmitted?.();
			trackRemoveSite();
		},
	});

	return (
		<FormDialog
			title="Remove site"
			open={open}
			onClose={onClose}
			actions={{
				confirm: { label: 'Remove site' },
				cancel: { label: 'Cancel' },
			}}
			onSubmit={() => site && mutate(site.id)}
		>
			{site && `Are you sure you wish to delete site ${site.name}? This action cannot be undone.`}
		</FormDialog>
	);
};

export default DeleteSiteForm;
